/**
 * Created by user on 2017/9/7.
 * 可视化组件的demo
 *实现功能：
 * 1) cluster points
 * 2) district pie ;
 * 3) district ring;
 * 4) feature points;
 * 5) point element  ;
 * 6）point element :overlay reduplicative points ;
 */
/**
 * 可视化组件
 */
'use strict';
define([
    '../base/PureComponent',
    '../layers/index',
    '../g2'
], function (
    PureComponent,
    lys,
    g2
) {
    /**
     * 可视化组件显示功能模式
     * @ignore
     * @enum {String}
     * @alias G.components.VisualComponent.DisplayMode
     **/
    var DisplayMode = {
        'PointNaturalDistribution': 'PointNaturalDistribution', //点状自然分布
        'PointClusterDistribution': 'PointClusterDistribution', //点状Cluster分布
        //点状Cluster分布,同一坐标不重叠
        'PointClusterDistributionReduplicative': 'PointClusterDistributionReduplicative',
        'Statistics_Ratio_Ring': 'Statistics_Ratio_Ring',//分组占比圆环统计
        'Statistics_Total_Circle': 'Statistics_Total_Circle',//分组总数圆统计
        //点状大量自然分布
        'PointQuantityNaturalDistribution': 'PointQuantityNaturalDistribution',
    };
    /**
     * 构造方法
     * @ignore
     * @constructor
     * @classdesc 可视化组件
     * @augments G.base.PureComponent
     * @alias G.components.VisualComponent
     * @param {Object} options - 必填，构造参数；
     * @param {String} options.id - 必填，组件实例id；
     * @param {String} options.name -必填，组件实例名称
     * @param {Object} options.map  -必填，ts-emap实例对象名称
     * @param {Object} options.symbolConfig - 必填，配置好的符号样式对象；

     * @param {Object} options.fieldsParam - 必填，关键字段参数配置
     * @param {String} options.fieldsParam.idKey - 必填:主键字段名
     * @param {String} options.fieldsParam.xField - 必填:数据记录中x坐标字段名
     * @param {String} options.fieldsParam.yField - 必填:数据记录中y坐标字段名
     * @param {String} options.displayMode -必填，组件地图显示功能模式，目前有6种，各个功能模式之间是互斥;详细参数说明{@link  G.components.VisualComponent.DisplayMode},以上一些参数是公共需要的参数，下面以后的参数根据功能模式来确定是否为必填。
     * @param {Boolean} options.showZero 当组件地图显示功能模式为统计功能模式时候，必填；false 统计数为零,不显示;true 统计数为零，显示。
     * @param {Object} options.reduplicativeParam - 不重复叠置的参数对象，options.displayMode="PointClusterDistributionReduplicative"时，必填；
     * @param {Boolean} options.reduplicativeParam.enalbeSpiderfy  重复点自动聚合效果
     * @param {Number} options.reduplicativeParam.spiderfyDistance 重复点识别的像素距离
     * @param {Number} options.reduplicativeParam.spiderfyLevel 重复点自动排列开始的地图级别
     * @param {Boolean} options.reduplicativeParam.enableCoincidenceCluster 级别小于spiderfyLevel时，重复点是否显示为聚合图标
     * @param {Number} options.reduplicativeParam.coincidenceClusterHoverThreshold 聚合效果时，鼠标滑过展开的最多个数
     * @param {Number} options.reduplicativeParam.coincidenceClusterWeight 聚合尺寸与字体大小比例
     * @param {Object} options.reduplicativeParam.coincidenceClusterMarkerSym 聚合符号样式参数对象
     * @param {Object} options.reduplicativeParam.coincidenceClusterTextSym   聚合文字的样式参数对象
     * @param {Boolean} options.reduplicativeParam.showSpiderLeg 是否显示重复点排列的连线,默认为true
     * @param {Number} options.reduplicativeParam.spiderfyThreshold 螺旋排布的最小阈值，否则用圆排布
     * @param {Number} options.reduplicativeParam.circleRadius  圆排布的半径，像素单位
     * @param {Object} options.reduplicativeParam.spiderfyLegSym 符号连线样式参数对象

     *
     * @example
     // 组件显示功能模式:G.components.VisualComponent.DisplayMode.PointClusterDistributionReduplicative
     //点状图片符号，小比例尺聚合分布显示,大比例尺大量同一坐标的符号不重叠显示
     var map;
     var symbolConfig;
     var fieldsParam;
     //赋值运算
     ......
     var displayMode= G.components.VisualComponent.DisplayMode.PointClusterDistributionReduplicative;
     var reduplicativeParam={
    //重复点自动聚合效果
    enalbeSpiderfy:true,
    //重复点识别的像素距离；
    spiderfyDistance:50,
    //重复点自动排列的级别；
    spiderfyLevel:10,
    //允许重复点自动排列;且级别小于spiderfyLevel时，重复点是否显示为聚合图标；
    enableCoincidenceCluster:true,
    //聚合效果时，鼠标滑过展开的最多个数
    coincidenceClusterHoverThreshold:12,
    //聚合尺寸与字体大小比例
    coincidenceClusterWeight:1.2,
    //默认标注的样式
    coincidenceClusterMarkerSym:{
            "borderColor":{
                "alpha": 150, "r": 150, "g": 120, "b": 226
            },
            "fillColor":{
                "alpha": 220, "r": 106, "g": 63, "b": 214
            }
        },
        //默认文字的样式
        coincidenceClusterTextSym:{
            "fontSize":12,
            "foreground": {"alpha": 255, "r": 255, "g": 255, "b": 255},
            "borderColor":{"alpha": 1, "r": 255, "g": 255, "b": 255}
        },
        //是否显示重复点排列的连线,默认为true
        showSpiderLeg:false,
        //超过这个值的点用螺旋，否则用圆排布；
        spiderfyThreshold:5,
        //圆排布的半径
        circleRadius:30,
        //连线的符号
        spiderfyLegSym:{
            "style":0,
            "width":2,
            "color":{"alpha":"150","r":0,"g":0,"b":255}
        }
    };
     var options={
                id:'visualCmp_test01',
                name:'visualCmp_test01',
                map:map,
                fieldsParam:fieldsParam,
                symbolConfig:symbolConfig,
                displayMode:displayMode, //1.3 显示功能模式
                //1.4 重复坐标信息的符号排列参数
                reduplicativeParam:reduplicativeParam
            };
     var visualCmp=new G.components.VisualComponent(options);
     */
    var component = PureComponent.extend({
        options: {},
        /**
         * 初始化组件
         * @param options
         */
        initialize: function (options) {
            PureComponent.prototype.initialize.call(this, options);
            this.changeVisualStyle(options);
        },

        /**
         * 增加显示数据
         * @param dataArr
         */
        addDispalyElements: function (dataArr) {
            this._layer.addElements(dataArr);
        },

        /**
         * 更新地图显示的数据【非统计专用】
         * @method
         * @memberOf G.components.VisualComponent.prototype
         * @param {Object} dataArr - 必填，需要更新数据描述,json对象表达
         * @example
         [{
                 "clientaddress":"北京市海淀区0",
                 "clientperson":"李四",
                 "clienttel":"13600112233",
                 "clientname":"大喇叭0",
                 "clientid":"termimal0",
                 "clientstatus":0,
                 "longitude":137.1502170804888,
                 "latitude":39.068018342368305,
                 "clientstyle":0
                 },{"clientaddress":"北京市海淀区0",
                 "clientperson":"李四",
                 "clienttel":"13600112233",
                 "clientname":"显示屏0",
                 "clientid":"termimal0",
                 "clientstatus":1,
                 "longitude":140.80123420106247,
                 "latitude":40.634906170889735,
                 "clientstyle":1
             }]
         */
        updateData: function (dataArr) {
            this._layer.clear();
            this._layer.addElements(dataArr);
        },

        /**
         * 刷新新地图统计【统计专用】
         * @method
         * @memberOf G.components.VisualComponent.prototype
         * @param {Object} dataStatistics  统计显示数据对象
         * @param {Object} dataStatistics.statisticsData 统计数据对象
         * @param {String} dataStatistics.key    统计对象标识
         * @param {String} dataStatistics.title  统计对象标题
         * @param {Object} dataStatistics.symbol 统计符号显示样式对象
         * @example
         //dataStatistics.statisticsData
         {   //统计数据对象
             statisticsData:
                {
                    "110000":
                        {   "code":"110000",
                            "lat":39.9236,
                            "lng":116.3809,
                            "name":"北京市",
                            "parentCode":"000000",
                            "value":917
                        },
                    "120000":
                        {
                            "code":"120000",
                            "lat":39.1311,
                            "lng":117.2034,
                             "name":"天津市",
                             "parentCode":"000000",
                             "value":812
                        }
                 },
             //统计标识
             key:'terminal',
             //统计的名称
             title:'终端统计',
             //统计符号显示样式对象
             symbol:{
                 "symbol": {
                     "borderColor": {
                         "alpha": 150, "r": 50, "g": 175, "b": 254
                     },
                     "fillColor": {
                         "alpha": 220, "r": 4, "g": 131, "b": 232
                     }
                 },
                 "label": {
                     "fontSize": 12,
                     "foreground": {"alpha": 255, "r": 255, "g": 255, "b": 255},
                     "borderColor": {"alpha": 1, "r": 255, "g": 255, "b": 255}
                 }
             }
         }
         */
        updateStatistics: function (dataStatistics) {
            if ((DisplayMode.Statistics_Ratio_Ring == this.options.displayMode)
                || (DisplayMode.Statistics_Total_Circle == this.options.displayMode)) {
                this._layer.updateStatistics(dataStatistics);
            }
        },

        /**
         * 设置地图数据集显示
         * @method
         * @memberOf G.components.VisualComponent.prototype
         * @param {Boolean} visible - 必填，true:可见；false 不可见。
         */
        setVisible: function (visible) {
            this._layer.setVisible(visible);
        },

        /**
         * 获取地图数据集显示状态
         * @method
         * @memberOf G.components.VisualComponent.prototype
         * @return {Boolean} true:可见；false 不可见。
         */
        getVisible: function () {
            return this._layer.getVisible();
        },

        changeVisualStyle: function (options) {
            if (this._layer != undefined) {
                this.map.getMap().removeLayer(this._layer);
                this._layer.destroy();
            }
            this.options.displayMode = options.displayMode;
            var selfObj = this;
            var doCreateLayer = {
                'PointNaturalDistribution': function (options) {
                    var layerFactory = new lys.LayerFactory();
                    var layer = layerFactory.createLayer(lys.TYPES.ELEMENT_POINT_LAYER, {
                        layerId: options.id,
                        //图层名称
                        layerName: options.layerName,
                        //图层分组
                        layerGroups: options.layerGroups,
                        //地图对象
                        map: selfObj.map.getMap(),
                        //主键字段名
                        idKey: options.fieldsParam.idKey,//'clientid',
                        //x属性名
                        xField: options.fieldsParam.xField,//'longitude',
                        //y属性名
                        yField: options.fieldsParam.yField,//'latitude',
                        //图层符号渲染
                        symbolConfig: jQuery.extend(true, {}, options.symbolConfig)
                    });
                    selfObj.map.getMap().addLayer(layer);
                    selfObj._layer = layer;
                },

                'PointClusterDistribution': function (options) {
                    var layerFactory = new lys.LayerFactory();
                    var layer = layerFactory.createLayer(lys.TYPES.ELEMENT_POINT_PIXEL_CLUSTER, {
                        layerId: options.id,
                        //图层名称
                        layerName: options.layerName,
                        //图层分组
                        layerGroups: options.layerGroups,
                        //地图对象
                        map: selfObj.map.getMap(),
                        //主键字段名
                        idKey: options.fieldsParam.idKey,//'clientid',
                        //x属性名
                        xField: options.fieldsParam.xField,//'longitude',
                        //y属性名
                        yField: options.fieldsParam.yField,//'latitude',
                        //图层符号渲染
                        symbolConfig: jQuery.extend(true, {}, options.symbolConfig)
                    });
                    selfObj.map.getMap().addLayer(layer);
                    selfObj._layer = layer;
                },

                'PointClusterDistributionReduplicative': function (options) {
                    var layerFactory = new lys.LayerFactory();
                    var redupParam = jQuery.extend(true, {}, options.reduplicativeParam);
                    var layer = layerFactory.createLayer(lys.TYPES.ELEMENT_POINT_DUPLICATE, {
                        layerId: options.id,
                        //图层名称
                        layerName: options.layerName,
                        //图层分组
                        layerGroups: options.layerGroups,
                        //地图对象
                        map: selfObj.map.getMap(),
                        //主键字段名
                        idKey: options.fieldsParam.idKey,//'clientid',
                        //x属性名
                        xField: options.fieldsParam.xField,//'longitude',
                        //y属性名
                        yField: options.fieldsParam.yField,//'latitude',
                        //图层符号渲染
                        symbolConfig: jQuery.extend(true, {}, options.symbolConfig),
                        //重复点识别的像素距离；
                        spiderfyDistance: redupParam.spiderfyDistance,//50,
                        //重复点自动排列的级别；
                        spiderfyLevel: redupParam.spiderfyLevel,//10,
                        //聚合效果时，鼠标滑过展开的最多个数
                        coincidenceClusterHoverThreshold: redupParam.coincidenceClusterHoverThreshold,//12,
                        //聚合尺寸与字体大小比例
                        coincidenceClusterWeight: redupParam.coincidenceClusterWeight,//1.2,
                        //默认标注的样式
                        coincidenceClusterMarkerSym: redupParam.coincidenceClusterMarkerSym,
                        //默认文字的样式
                        coincidenceClusterTextSym: redupParam.coincidenceClusterTextSym,
                        //是否显示重复点排列的连线,默认为true
                        showSpiderLeg: redupParam.showSpiderLeg,//false,
                        //超过这个值的点用螺旋，否则用圆排布；
                        spiderfyThreshold: redupParam.spiderfyThreshold,//5,
                        //圆排布的半径
                        circleRadius: redupParam.circleRadius,//30,
                        //连线的符号样式
                        spiderfyLegSym: redupParam.spiderfyLegSym
                    });
                    selfObj.map.getMap().addLayer(layer);
                    selfObj._layer = layer;
                },
                'Statistics_Ratio_Ring': function (options) {
                    var layerFactory = new lys.LayerFactory();
                    //分类统计图层
                    var layer = layerFactory.createLayer(lys.TYPES.RING_STATISTICS_LAYER, {
                        layerId: options.id,
                        //图层名称
                        layerName: options.layerName,
                        //图层分组
                        layerGroups: options.layerGroups,
                        //地图对象
                        map: selfObj.map.getMap(),
                        //x属性名
                        xField: options.fieldsParam.xField,//'longitude',
                        //y属性名
                        yField: options.fieldsParam.yField,//'latitude',
                        showZero: options.showZero,//如果统计数为零是否显示
                    });
                    selfObj.map.getMap().addLayer(layer);
                    selfObj._layer = layer;
                },
                'Statistics_Total_Circle': function (options) {
                    var layerFactory = new lys.LayerFactory();
                    //统计图层
                    var layer = layerFactory.createLayer(lys.TYPES.PIE_STATISTICS_LAYER, {
                        layerId: options.id,
                        //图层名称
                        layerName: options.layerName,
                        //图层分组
                        layerGroups: options.layerGroups,
                        //地图对象
                        map: selfObj.map.getMap(),
                        //x属性名
                        xField: options.fieldsParam.xField,//'longitude',
                        //y属性名
                        yField: options.fieldsParam.yField,//'latitude',
                        showZero: options.showZero,//如果统计数为零是否显示
                    });
                    selfObj.map.getMap().addLayer(layer);
                    selfObj._layer = layer;
                },

                'PointQuantityNaturalDistribution': function (options) {
                    var layerFactory = new lys.LayerFactory();
                    var layer = layerFactory.createLayer(lys.TYPES.FEATURE_POINT_LAYER, {
                        layerId: options.id,
                        //图层名称
                        layerName: options.layerName,
                        //图层分组
                        layerGroups: options.layerGroups,
                        //地图对象
                        map: selfObj.map.getMap(),
                        idKey: options.fieldsParam.idKey,//主键字段名
                        xField: options.fieldsParam.xField,//x属性名
                        yField: options.fieldsParam.yField,//y属性名
                        symbolConfig: jQuery.extend(true, {}, options.symbolConfig),//图层符号渲染
                    });
                    selfObj.map.getMap().addLayer(layer);
                    selfObj._layer = layer;
                },
            };
            if (doCreateLayer[options.displayMode] == undefined) {
                console.error(options.displayMode + "没有对应的处理方法！");
                return
            }
            doCreateLayer[options.displayMode](options);
        }
        ,
        /**
         * 获取图层：ts-gis layer
         * @method
         * @memberOf G.components.VisualComponent.prototype
         * @returns {*|G.lys.BaseLayer}
         */
        getLayer: function () {
            return this._layer;
        },
        /**
         * 清除可视化组件显示结果
         * @method
         * @memberOf G.components.VisualComponent.prototype
         */
        clear: function () {
            this._layer.clear();
        },
        /**
         * 传入屏幕坐标，返回选中的单条记录
         * @param screenX
         * @param screenY
         * @returns {*}
         */
        hitTest: function (screenX, screenY) {
            var ele = this._layer.hitTest(screenX, screenY);
            return ele;
        },

        /**
         * 缩放到最佳全图效果
         */
        adjustExtent: function () {
            var extentArr = this._layer.getLayerExtent();
            var envelope = new g2.sfs.Envelope({
                minx: extentArr[0],
                miny: extentArr[1],
                maxx: extentArr[2],
                maxy: extentArr[3],
                spatialReference: this.map.spatialReference
            });
            var padding = 5;
            this.map.getMap().pan(envelope, [padding, padding, padding, padding]);
        },

        /**
         * 缩放到最佳全图效果
         * @method
         * @memberOf G.components.VisualComponent.prototype
         */
        fullExtent: function () {
            this.adjustExtent();
        },
        /**
         * 销毁组件
         * @method
         * @memberOf G.components.VisualComponent.prototype
         */
        destroy: function () {
            this._layer.clear();
            this._layer.destroy();
            PureComponent.prototype.destroy.call(this);
        }
    });
    component.DisplayMode = DisplayMode;
    return component;
});
